<template>
      <div ref='viewer'></div>
    
</template>

<script>
/* eslint-disable */
import WebViewer from '@pdftron/pdfjs-express'


export default {
  
  name: 'WebViewer',
  props: {
    path: String,
    url: String
  },
  mounted: function () {
        WebViewer({
            path: this.path,
            initialDoc: this.url,
          }, this.$refs.viewer).then((instance) => {
            // call apis here
            instance.setTheme('dark');
            instance.disableFeatures([instance.Feature.Print])
            instance.disableFeatures([instance.Feature.Annotations])
            instance.disableFeatures([instance.Feature.Copy]);
            instance.setFitMode(instance.FitMode.FitWidth);

          });
    },
    data () {
      return {
       
        
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

body{
  --secondary-color: #fff;
}
div {
  width: 100%; 
  height: 100vh;
}
</style>
